import { render, staticRenderFns } from "./newClaimItem.vue?vue&type=template&id=44faa624&"
import script from "./newClaimItem.vue?vue&type=script&lang=js&"
export * from "./newClaimItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44faa624')) {
      api.createRecord('44faa624', component.options)
    } else {
      api.reload('44faa624', component.options)
    }
    module.hot.accept("./newClaimItem.vue?vue&type=template&id=44faa624&", function () {
      api.rerender('44faa624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Page/EssAdmin/Claim/ClaimType/components/newClaimItem.vue"
export default component.exports